import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = {
  key: 1,
  class: "font-semibold mt-3"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Завершение заказа (Указать данные выставления клиенту)",
    loading: _ctx.isLoading,
    scrollable: "",
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmitted
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "mt-3",
        placeholder: "Выставление за перевозку",
        value: _ctx.delivery_state.paid_price_total,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.delivery_state.paid_price_total) = $event)),
        "is-invalid": _ctx.state_form$.paid_price_total.$error,
        "validation-errors": _ctx.state_form$.paid_price_total.$errors,
        type: "number"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      (_ctx.delivery_state.has_downtime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: "Количество часов простоя для выставления",
              value: _ctx.delivery_state.downtime.hours_for_client,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.delivery_state.downtime.hours_for_client) = $event)),
              "is-invalid": _ctx.state_form$.downtime.hours_for_client.$error,
              "validation-errors": _ctx.state_form$.downtime.hours_for_client.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: `Выставление простоя ${_ctx.rateType}`,
              value: _ctx.delivery_state.downtime.paid_price,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.delivery_state.downtime.paid_price) = $event)),
              "is-invalid": _ctx.state_form$.downtime.paid_price.$error,
              "validation-errors": _ctx.state_form$.downtime.paid_price.$errors
            }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.delivery_state.additional_services.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Доп услуги при заборе"))
        : _createCommentVNode("", true),
      (_ctx.delivery_state.additional_services.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Адрес: " + _toDisplayString(_ctx.senderAddress || '-'), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delivery_state.additional_services, (service, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `service-${idx}`,
          class: "mt-2 grid gap-x-3 items-center",
          style: { gridTemplateColumns: '1fr 300px' }
        }, [
          _createElementVNode("p", null, _toDisplayString(service.type_name), 1),
          _createVNode(_component_the_input, {
            placeholder: "Выставление клиенту за час (с НДС)",
            value: service.paid_price_per_hour,
            "onUpdate:value": ($event: any) => ((service.paid_price_per_hour) = $event),
            "is-invalid": !service.paid_price_per_hour,
            type: "number"
          }, null, 8, ["value", "onUpdate:value", "is-invalid"])
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delivery_state.stocks, (stock, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `stock-${i}`,
          class: "mt-3"
        }, [
          (stock.additional_service.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(stock.directionName), 1),
                _createElementVNode("p", null, " Адрес: " + _toDisplayString(stock.receiver && stock.receiver.address ? stock.receiver.address : '-'), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stock.additional_service, (service, j) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `stock-service-${j}`,
              class: "mt-2 grid gap-x-3 items-center",
              style: { gridTemplateColumns: '1fr 300px' }
            }, [
              _createElementVNode("p", null, _toDisplayString(service.type_name), 1),
              _createVNode(_component_the_input, {
                placeholder: "Выставление клиенту за час  (с НДС)",
                value: service.paid_price_per_hour,
                "is-invalid": !service.paid_price_per_hour,
                type: "number",
                "onUpdate:value": (value) => _ctx.onChangeStockAdditionalService(i, j, value)
              }, null, 8, ["value", "is-invalid", "onUpdate:value"])
            ]))
          }), 128))
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}